import React from "react";

import {
    padlock,
    locked,
    unlocked,
    iconHost,
    icon,
    body,
    shackle,
    keyhole,
} from "./padlock.module.scss";

interface IPadlockProps {
    isLocked?: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    className?: string;
    ariaLabel?: string;
    tourTarget?: string;
}

const Padlock: React.FC<IPadlockProps> = ({
    isLocked = false,
    onClick,
    className = "",
    ariaLabel = "Zablokuj lub odblokuj zmianę produktu",
    tourTarget,
}) => {
    return (
        <button
            onClick={onClick}
            className={`${padlock} ${isLocked ? locked : unlocked} ${className}`}
            type="button"
            aria-label={ariaLabel}
            aria-pressed={isLocked}
            data-generator-tour={tourTarget}
        >
            <span className={iconHost} aria-hidden="true">
                <svg
                    className={icon}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="-2 -8 25.086 38"
                    focusable="false"
                >
                    <path
                        className={body}
                        d="M18.373 29.999H2.714A2.717 2.717 0 0 1 0 27.285V14.003a2.717 2.717 0 0 1 2.714-2.714h15.659a2.717 2.717 0 0 1 2.713 2.714v13.282a2.717 2.717 0 0 1-2.713 2.714M2.714 13.29a.713.713 0 0 0-.712.713v13.282a.713.713 0 0 0 .712.712h15.659a.713.713 0 0 0 .712-.712V14.003a.713.713 0 0 0-.712-.713Z"
                    />
                    <path
                        className={shackle}
                        d="M5.058 13.291V6.89A4.89 4.89 0 0 1 9.948 2h1.189a4.89 4.89 0 0 1 4.89 4.89v6.401"
                    />
                    <path
                        className={keyhole}
                        d="M12.461 19.494a1.918 1.918 0 1 0-3.07 1.532.189.189 0 0 1 .074.151v2.343a.192.192 0 0 0 .192.192h1.773a.192.192 0 0 0 .192-.192v-2.341a.192.192 0 0 1 .075-.154 1.914 1.914 0 0 0 .764-1.532"
                    />
                </svg>
            </span>
        </button>
    );
};

export default Padlock;
